import { openMultistepSection } from "./multistepFunctions";
/**
 * Multistep Checkout - Ticket Price Section
 *
 * @param {*} priceSection
 */

export const checkoutTicketSelect = (priceSection) => {
  const tickets = priceSection.querySelectorAll(".ticket-row");
  if (tickets.length > 0) {
    tickets.forEach((ticket) => {
      let input = ticket.querySelector(".input-qty-tickets"),
        btnMinus = ticket.querySelector(".btn-minus-tickets"),
        btnPlus = ticket.querySelector(".btn-plus-tickets");
      input.value = 0;

      // Bottone di decremento
      btnMinus.addEventListener("click", () => {
        if (totalValues(tickets) > parseInt(input.min)) {
          removeTicketFromCart(tickets, input);
        }
      });

      // Bottone di incremento
      btnPlus.addEventListener("click", () => {
        if (totalValues(tickets) < parseInt(input.max)) {
          addTicketToCart(tickets, input);
        }
      });
    });
  }
};

/**
 * Remove Ticket from Cart
 *
 * @param {*} tickets
 * @param {*} input
 */

const removeTicketFromCart = (tickets, input) => {
  let oldValue = parseInt(input.value);
  input.stepDown();
  if (totalValues(tickets) === parseInt(input.min)) {
    toggleDisableBtns(tickets, "btn-minus-tickets", true);
  }
  if (parseInt(input.value) != oldValue) {
    toggleDisableBtns(tickets, "btn-plus-tickets", false);
  }
};

/**
 * Add Ticket to Cart
 *
 * @param {*} tickets
 * @param {*} input
 */

const addTicketToCart = (tickets, input) => {
  let oldValue = parseInt(input.value);
  input.stepUp();
  if (totalValues(tickets) === parseInt(input.max)) {
    toggleDisableBtns(tickets, "btn-plus-tickets", true);
  }
  if (parseInt(input.value) != oldValue) {
    toggleDisableBtns(tickets, "btn-minus-tickets", false);
  }
};

/**
 * Disable / Enable Ticket Buttons
 *
 * @param {*} ticketSelector
 * @param {*} btnClass
 * @param {*} boolValue
 */

const toggleDisableBtns = (ticketSelector, btnClass, boolValue) => {
  ticketSelector.forEach((btn) => {
    if (btn.querySelector("." + btnClass)) {
      btn.querySelector("." + btnClass).disabled = boolValue;
    }
  });
};

/**
 * Check selectred Ticket quantity
 *
 * @param {*} ticketSelector
 * @returns
 */

const totalValues = (ticketSelector) => {
  let total = 0,
    orderData = "";
  ticketSelector.forEach((selector) => {
    let label = selector.querySelector(".ticket-label").innerHTML.trim(),
      quantityInput = parseInt(selector.querySelector(".qty-input").value),
      priceSpan = selector.querySelector(".ticket-price-span"),
      ticketPrice = parseFloat(priceSpan.dataset.finalPrice).toFixed(2);
    total += quantityInput;

    let ticketAdd = parseFloat(quantityInput * ticketPrice).toFixed(2);
    priceSpan.innerHTML = (quantityInput > 1) ? ticketAdd.toString() : ticketPrice.toString();
    orderData += label + "=" + quantityInput.toString() + "=" + ticketPrice.toString() + "&";
  });
  if (total > 0) {
    openMultistepSection("final-checkout-section");
  }
  document.getElementById("final-checkout-section").dataset.selectedQuantity = orderData.slice(0, -1);
  return total;
};
